// Per-kill scoring and the bonus-city award rule.

import type { GameState, EnemyKind, FlyingKind } from '../state/types';
import type { ApplyScoring } from '../sim/contracts';
import {
  BONUS_CITY_INTERVAL,
  POINTS_PER_FLYING,
  POINTS_PER_MISSILE,
  POINTS_PER_SMART_BOMB,
} from '../constants';

/** Base point value (before multiplier) for destroying a given enemy kind. */
export function pointsForKind(kind: EnemyKind | FlyingKind): number {
  switch (kind) {
    case 'icbm':
      return POINTS_PER_MISSILE;
    case 'smartBomb':
      return POINTS_PER_SMART_BOMB;
    case 'bomber':
    case 'satellite':
      return POINTS_PER_FLYING;
  }
}

/** Adds points and awards a reserve city for each BONUS_CITY_INTERVAL crossed. */
export function awardPoints(state: GameState, points: number): GameState {
  const score = state.score + points;
  let progress = state.bonusCityProgress + points;
  let reserveCities = state.reserveCities;
  while (progress >= BONUS_CITY_INTERVAL) {
    reserveCities += 1;
    progress -= BONUS_CITY_INTERVAL;
  }
  return { ...state, score, bonusCityProgress: progress, reserveCities };
}

/** Consumes pendingKills, scoring each at the current multiplier, then clears them. */
export const applyScoring: ApplyScoring = (state) => {
  if (state.pendingKills.length === 0) return state;
  let points = 0;
  for (const kill of state.pendingKills) {
    points += pointsForKind(kill.kind) * state.scoreMultiplier;
  }
  return { ...awardPoints(state, points), pendingKills: [] };
};
